import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import '../../assets/css/my-Profile.css';

function Myprofile() {
  return (
      <section className="my-Profile-section">  
    <div className='container'>
     <div className='progile-user'>  </div>   
    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <Row>
        <Col sm={2}>
        <div className='dasboard-list'> 
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="first"><i className="bi bi-box"></i> Dashboard </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second"><i className="bi bi-people-fill"></i> Customers</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="third"><i className="bi bi-bag-check"></i> My Orders</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="four"><i className="bi bi-hand-index"></i> Hold Order</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="five"><i className="bi bi-journal-check"></i> Billing</Nav.Link>
            </Nav.Item>
          </Nav>
          </div>
        </Col>
        <Col sm={9}>
          <Tab.Content>

            <Tab.Pane eventKey="first">First tab content</Tab.Pane>
            <Tab.Pane eventKey="second">Second tab content</Tab.Pane>
            <Tab.Pane eventKey="third">Second tab content</Tab.Pane>
            <Tab.Pane eventKey="four">Second tab content</Tab.Pane>
            <Tab.Pane eventKey="five">Second tab content</Tab.Pane>

          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
          </div>
      </section>
  );
}
export default Myprofile;